import {
    useEffect,
    useState
} from "react";

import {
    useNavigate
} from "react-router-dom";

import toast from "react-hot-toast";
import Select from "react-select";
import API from "../../services/api";

function AddPurchase() {

    const navigate =
        useNavigate();

    const [suppliers,
        setSuppliers] =
        useState([]);

    const [products,
        setProducts] =
        useState([]);

    const [wallets, setWallets] =
        useState([]);

    const [form, setForm] =
        useState({
            supplier_id: "",
            wallet_id: "",
            invoice_no: "",
            purchase_date:
                new Date()
                    .toISOString()
                    .split("T")[0],
            discount: 0,
            paid_amount: 0
        });

    const [items,
        setItems] =
        useState([
            {
                product_id: "",
                qty: 1,
                purchase_price: 0,
                gst_percent: 0
            }
        ]);

    useEffect(() => {
        loadData();
    }, []);

    const loadData =
        async () => {

            try {

                const [
                    supplierRes,
                    productRes,
                    walletRes
                ] = await Promise.all([

                    API.get("/suppliers"),

                    API.get("/products"),

                    API.get("/wallets")

                ]);

                setSuppliers(
                    supplierRes.data.suppliers || []
                );

                setProducts(
                    productRes.data.products || []
                );

                setWallets(
                    walletRes.data.wallets || []
                );

            } catch (err) {

                console.log(err);

            }

        };

    const handleItemChange =
        (
            index,
            field,
            value
        ) => {

            const updated =
                [...items];

            updated[index][field] =
                value;

            setItems(updated);

        };

    const addRow =
        () => {

            setItems([
                ...items,
                {
                    product_id: "",
                    qty: 1,
                    purchase_price: 0,
                    gst_percent: 0
                }
            ]);

        };

    const removeRow =
        (index) => {

            const updated =
                items.filter(
                    (_, i) =>
                        i !== index
                );

            setItems(updated);

        };

    const subtotal =
        items.reduce(
            (sum, item) =>
                sum +
                (
                    Number(item.qty) *
                    Number(item.purchase_price)
                ),
            0
        );

    const gstTotal =
        items.reduce(
            (sum, item) => {

                const amount =
                    Number(item.qty) *
                    Number(item.purchase_price);

                return (
                    sum +
                    (
                        amount *
                        Number(
                            item.gst_percent
                        ) / 100
                    )
                );

            },
            0
        );

    const discount =
        Number(form.discount || 0);

    const grandTotal =
        subtotal +
        gstTotal -
        discount;

    const paidAmount =
        Number(form.paid_amount || 0);

    const dueAmount =
        Math.max(
            grandTotal -
            paidAmount,
            0
        );

    const paymentStatus = dueAmount === 0
        ? "Paid"
        : paidAmount > 0
            ? "Partial"
            : "Due";

    const submit = async (e) => {

        e.preventDefault();

        try {

            if (!form.wallet_id) {

                return toast.error(
                    "Please select wallet."
                );

            }

            if (!form.supplier_id) {

                return toast.error(
                    "Please select supplier."
                );

            }

            if (!form.invoice_no.trim()) {

                return toast.error(
                    "Invoice number is required."
                );

            }

            if (items.length === 0) {

                return toast.error(
                    "Please add at least one product."
                );

            }

            for (const item of items) {

                if (!item.product_id) {

                    return toast.error(
                        "Please select all products."
                    );

                }

                if (Number(item.qty) <= 0) {

                    return toast.error(
                        "Quantity should be greater than zero."
                    );

                }

                if (Number(item.purchase_price) <= 0) {

                    return toast.error(
                        "Purchase price should be greater than zero."
                    );

                }

            }

            if (paidAmount > grandTotal) {
                return toast.error(
                    "Paid amount cannot exceed Grand Total."
                );

            }

            await API.post(
                "/purchases",
                {
                    ...form,
                    subtotal,
                    gst_total: gstTotal,
                    grand_total: grandTotal,
                    discount,
                    paid_amount: paidAmount,
                    due_amount: dueAmount,
                    payment_status: paymentStatus,
                    items
                }
            );

            toast.success(
                "Purchase Added Successfully."
            );

            navigate(
                "/admin/purchases"
            );

        } catch (err) {

            console.log(err);

            toast.error(

                err.response?.data?.message ||

                "Server Error"

            );

        }

    };

    const handleProductChange = (
        index,
        selected
    ) => {

        const product =
            products.find(
                p =>
                    p.id ===
                    selected.value
            );

        const updated =
            [...items];

        updated[index] = {
            ...updated[index],
            product_id:
                product.id,
            purchase_price:
                product.purchase_price,
            gst_percent:
                product.gst_percent
        };

        setItems(updated);

    };

    const customSelectStyles = {
        control: (provided) => ({
            ...provided,
            backgroundColor: "#000",
            borderColor: "#333",
            minHeight: "52px",
            boxShadow: "none",
        }),

        singleValue: (provided) => ({
            ...provided,
            color: "#fff",
        }),

        input: (provided) => ({
            ...provided,
            color: "#fff",
        }),

        placeholder: (provided) => ({
            ...provided,
            color: "#888",
        }),

        menu: (provided) => ({
            ...provided,
            backgroundColor: "#111",
            zIndex: 9999,
        }),

        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused
                ? "#eab308"
                : "#111",
            color: state.isFocused
                ? "#000"
                : "#fff",
            cursor: "pointer",
        }),
    };

    return (<div>

        <h1
            className="
    text-3xl
    font-bold
    mb-6
  "
        >
            Add Purchase
        </h1>

        <form
            onSubmit={submit}
            className="
    bg-[#111]
    p-6
    rounded-2xl
  "
        >



            <div
                className="
      grid
      md:grid-cols-4
      gap-4
      mb-6
    "
            >




                {/* Wallet */}

                <div>

                    <label
                        className="
            block
            mb-2
            font-medium
            text-gray-300
            "
                    >
                        Wallet
                    </label>

                    <select
                        value={form.wallet_id}
                        onChange={(e) =>
                            setForm({
                                ...form,
                                wallet_id: e.target.value
                            })
                        }
                        className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            focus:border-yellow-500
            outline-none
            "
                        required
                    >

                        <option value="">
                            Select Wallet
                        </option>

                        {wallets.map(wallet => (

                            <option
                                key={wallet.id}
                                value={wallet.id}
                            >
                                {wallet.wallet_name}
                                {" "}
                                (₹{Number(wallet.balance).toFixed(2)})
                            </option>

                        ))}

                    </select>

                </div>

                {/* Supplier */}

                <div>

                    <label
                        className="
            block
            mb-2
            font-medium
            text-gray-300
            "
                    >
                        Supplier
                    </label>

                    <select
                        value={form.supplier_id}
                        onChange={(e) =>
                            setForm({
                                ...form,
                                supplier_id: e.target.value
                            })
                        }
                        className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            focus:border-yellow-500
            outline-none
            "
                        required
                    >

                        <option value="">
                            Select Supplier
                        </option>

                        {suppliers.map((supplier) => (

                            <option
                                key={supplier.id}
                                value={supplier.id}
                            >
                                {supplier.supplier_name}
                            </option>

                        ))}

                    </select>

                </div>

                {/* Invoice No */}

                <div>

                    <label
                        className="
            block
            mb-2
            font-medium
            text-gray-300
            "
                    >
                        Invoice No
                    </label>

                    <input
                        type="text"
                        placeholder="Enter Invoice Number"
                        value={form.invoice_no}
                        onChange={(e) =>
                            setForm({
                                ...form,
                                invoice_no: e.target.value
                            })
                        }
                        className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            focus:border-yellow-500
            outline-none
            "
                        required
                    />

                </div>

                {/* Purchase Date */}

                <div>

                    <label
                        className="
            block
            mb-2
            font-medium
            text-gray-300
            "
                    >
                        Purchase Date
                    </label>

                    <input
                        type="date"
                        value={form.purchase_date}
                        onChange={(e) =>
                            setForm({
                                ...form,
                                purchase_date: e.target.value
                            })
                        }
                        className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            focus:border-yellow-500
            outline-none
            "
                    />

                </div>

                {/* ===========================
    Discount
=========================== */}

                <div>

                    <label
                        className="
    block
    mb-2
    "
                    >
                        Discount
                    </label>

                    <input
                        type="number"
                        min="0"
                        value={form.discount}
                        onChange={(e) =>

                            setForm({

                                ...form,

                                discount:
                                    e.target.value

                            })

                        }
                        className="
    w-full
    p-3
    rounded-xl
    bg-black
    border
    border-yellow-500/20
    "
                    />

                </div>

                {/* ===========================
    Paid Amount
=========================== */}

                <div>

                    <label
                        className="
    block
    mb-2
    "
                    >
                        Paid Amount
                    </label>

                    <input
                        type="number"
                        min="0"
                        max={grandTotal}
                        value={form.paid_amount}
                        onChange={(e) =>

                            setForm({

                                ...form,

                                paid_amount:
                                    e.target.value

                            })

                        }
                        className="
    w-full
    p-3
    rounded-xl
    bg-black
    border
    border-yellow-500/20
    "
                    />

                </div>

                {/* ===========================
    Due Amount
=========================== */}

                <div>

                    <label
                        className="
    block
    mb-2
    "
                    >
                        Due Amount
                    </label>

                    <input
                        type="text"
                        readOnly
                        value={dueAmount.toFixed(2)}
                        className="
    w-full
    p-3
    rounded-xl
    bg-gray-900
    border
    border-red-500/30
    text-red-400
    font-semibold
    "
                    />

                </div>

                {/* ===========================
    Payment Status
=========================== */}

                <div>

                    <label
                        className="
    block
    mb-2
    "
                    >
                        Payment Status
                    </label>

                    <input
                        type="text"
                        readOnly
                        value={paymentStatus}
                        className={`
    w-full
    p-3
    rounded-xl
    font-semibold

    ${paymentStatus === "Paid"

                                ? "bg-green-500/20 text-green-400"

                                : paymentStatus === "Partial"

                                    ? "bg-yellow-500/20 text-yellow-400"

                                    : "bg-red-500/20 text-red-400"

                            }
    `}
                    />

                </div>

            </div>


            <div
                className="
      overflow-x-auto
    "
            >

                <div className="space-y-4">

                    {items.map((item, index) => {

                        const amount =
                            Number(item.qty) *
                            Number(item.purchase_price);

                        return (

                            <div
                                key={index}
                                className="
grid
grid-cols-12
gap-3
items-end
border-b
border-yellow-500/10
pb-4
"
                            >

                                <div className="col-span-12 md:col-span-4">

                                    <label className="block mb-2">
                                        Product
                                    </label>

                                    <Select
                                        styles={customSelectStyles}
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                        placeholder="Search Product..."
                                        options={products.map((product) => ({
                                            value: product.id,
                                            label: `${product.name} (Stock: ${product.stock})`
                                        }))}
                                        value={
                                            products
                                                .filter(
                                                    p => p.id == item.product_id
                                                )
                                                .map(
                                                    p => ({
                                                        value: p.id,
                                                        label: `${p.name} (Stock: ${p.stock})`
                                                    })
                                                )[0]
                                        }
                                        onChange={(selected) =>
                                            handleProductChange(
                                                index,
                                                selected
                                            )
                                        }
                                    />

                                </div>

                                <div className="col-span-6 md:col-span-2">

                                    <label className="block mb-2">
                                        Qty
                                    </label>

                                    <input
                                        type="number"
                                        min="1"
                                        value={item.qty}
                                        onChange={(e) =>
                                            handleItemChange(
                                                index,
                                                "qty",
                                                e.target.value
                                            )
                                        }
                                        className="
w-full
p-3
bg-black
rounded-xl
"
                                    />

                                </div>

                                <div className="col-span-6 md:col-span-2">

                                    <label className="block mb-2">
                                        Purchase Price
                                    </label>

                                    <input
                                        type="number"
                                        value={item.purchase_price}
                                        onChange={(e) =>
                                            handleItemChange(
                                                index,
                                                "purchase_price",
                                                e.target.value
                                            )
                                        }
                                        className="
w-full
p-3
bg-black
rounded-xl
"
                                    />

                                </div>

                                <div className="col-span-6 md:col-span-1">

                                    <label className="block mb-2">
                                        GST %
                                    </label>

                                    <input
                                        type="number"
                                        value={item.gst_percent}
                                        onChange={(e) =>
                                            handleItemChange(
                                                index,
                                                "gst_percent",
                                                e.target.value
                                            )
                                        }
                                        className="
w-full
p-3
bg-black
rounded-xl
"
                                    />

                                </div>

                                <div className="col-span-3 md:col-span-2">

                                    <label className="block mb-2">
                                        Amount
                                    </label>

                                    <div
                                        className="
p-3
bg-black
rounded-xl
text-yellow-400
font-bold
"
                                    >
                                        ₹{amount.toFixed(2)}
                                    </div>

                                </div>

                                <div className="col-span-3 md:col-span-1">

                                    <button
                                        type="button"
                                        onClick={() =>
                                            removeRow(index)
                                        }
                                        className="
w-full
bg-red-500
py-3
rounded-xl
"
                                    >
                                        ✕
                                    </button>

                                </div>

                            </div>

                        );
                    })}

                </div>

            </div>

            <div
                className="
    mt-8
    flex
    justify-end
    "
            >

                <div
                    className="
        w-full
        md:w-[420px]
        bg-black
        border
        border-yellow-500/20
        rounded-2xl
        p-6
        "
                >

                    <h2
                        className="
            text-xl
            font-bold
            mb-5
            "
                    >
                        Purchase Summary
                    </h2>

                    {/* Subtotal */}

                    <div className="flex justify-between mb-3">

                        <span className="text-gray-400">
                            Subtotal
                        </span>

                        <span>
                            ₹{subtotal.toFixed(2)}
                        </span>

                    </div>

                    {/* GST */}

                    <div className="flex justify-between mb-3">

                        <span className="text-gray-400">
                            GST
                        </span>

                        <span>
                            ₹{gstTotal.toFixed(2)}
                        </span>

                    </div>

                    {/* Discount */}

                    <div className="flex justify-between mb-3">

                        <span className="text-gray-400">
                            Discount
                        </span>

                        <span className="text-red-400">
                            - ₹{discount.toFixed(2)}
                        </span>

                    </div>

                    <hr className="border-yellow-500/20 my-4" />

                    {/* Grand Total */}

                    <div className="flex justify-between">

                        <span className="font-semibold">
                            Grand Total
                        </span>

                        <span
                            className="
                text-2xl
                font-bold
                text-yellow-400
                "
                        >
                            ₹{grandTotal.toFixed(2)}
                        </span>

                    </div>

                    <hr className="border-yellow-500/20 my-4" />

                    {/* Paid */}

                    <div className="flex justify-between mb-3">

                        <span className="text-gray-400">
                            Paid Amount
                        </span>

                        <span className="text-green-400">
                            ₹{paidAmount.toFixed(2)}
                        </span>

                    </div>

                    {/* Due */}

                    <div className="flex justify-between mb-3">

                        <span className="text-gray-400">
                            Due Amount
                        </span>

                        <span
                            className={`
                font-bold

                ${dueAmount === 0

                                    ? "text-green-400"

                                    : "text-red-400"

                                }
                `}
                        >
                            ₹{dueAmount.toFixed(2)}
                        </span>

                    </div>

                    {/* Status */}

                    <div className="flex justify-between mt-5">

                        <span className="text-gray-400">
                            Payment Status
                        </span>

                        <span
                            className={`
                px-3
                py-1
                rounded-full
                text-sm
                font-semibold

                ${paymentStatus === "Paid"

                                    ? "bg-green-600"

                                    : paymentStatus === "Partial"

                                        ? "bg-yellow-500 text-black"

                                        : "bg-red-600"

                                }
                `}
                        >

                            {paymentStatus}

                        </span>

                    </div>

                </div>

            </div>

            <div
                className="
flex
justify-between
items-center
mt-8
flex-wrap
gap-4
"
            >

                <div>

                    <button
                        type="button"
                        onClick={addRow}
                        className="
bg-blue-500
hover:bg-blue-600
px-6
py-3
rounded-xl
font-semibold
transition
"
                    >
                        + Add Product
                    </button>

                </div>

                <div
                    className="
flex
gap-3
"
                >

                    <button
                        type="button"
                        onClick={() =>
                            navigate(
                                "/admin/purchases"
                            )
                        }
                        className="
bg-gray-700
hover:bg-gray-600
px-6
py-3
rounded-xl
transition
"
                    >
                        Cancel
                    </button>

                    <button
                        type="submit"
                        className="
bg-yellow-500
hover:bg-yellow-400
text-black
font-bold
px-8
py-3
rounded-xl
transition
"
                    >
                        Save Purchase
                    </button>

                </div>

            </div>

        </form>

    </div>

    );
}

export default AddPurchase;
